import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=ca9f197a&scoped=true&"
import script from "./shopList.vue?vue&type=script&lang=js&"
export * from "./shopList.vue?vue&type=script&lang=js&"
import style1 from "./shopList.vue?vue&type=style&index=1&id=ca9f197a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9f197a",
  null
  
)

export default component.exports